<mat-card class="custom-card" appearance="outlined">
  <div
    class="custom-card-header d-flex align-items-center justify-content-center"
  >
    <mat-card-title>{{ nombrePersona }}</mat-card-title>
  </div>

  <mat-card-content>
    <form [formGroup]="form" class="form-salud">
      <div *ngFor="let cuestionario of cuestionarios; let j = index">
        CUESTIONARIO {{ j + 1 }} - {{ cuestionario.nombre }}
        <div *ngFor="let seccion of cuestionario.secciones; let i = index">
          <div class="card bg-light mb-3">
            <div class="card-header">
              {{ seccion.titulo }}
            </div>
            <div class="card-body">
              <p class="card-text">
                {{ seccion.descripcion }}
              </p>
              <div *ngFor="let pregunta of seccion.preguntas">
                <ng-container *ngIf="debeMostrarPregunta(pregunta)">
                  <label
                    class="mat-radio-label"
                    ngbTooltip="{{ pregunta.textoAyuda }}"
                  >
                    <ng-container *ngIf="pregunta.nivelPregunta === 1">
                      {{ pregunta.orden }}. {{ pregunta.enunciando }}
                    </ng-container>
                    <ng-container *ngIf="pregunta.nivelPregunta === 2">
                      {{ pregunta.orden }}.{{ pregunta.nivelPregunta }}
                      {{ pregunta.enunciando }}
                    </ng-container>
                  </label>
                  <!-- NUMERICA -->
                  <div>
                    <ng-container>
                      <mat-form-field
                        class="w-100"
                        *ngIf="
                          pregunta.tipoPregunta.tipoPregunta === 'NUMERICA'
                        "
                      >
                        <input
                          matInput
                          type="number"
                          [formControlName]="'pregunta_' + pregunta.id"
                        />
                        <mat-error
                          *ngIf="
                            form.get('pregunta_' + pregunta.id)?.invalid &&
                            form.get('pregunta_' + pregunta.id)?.touched
                          "
                        >
                          Este campo es obligatorio
                        </mat-error>
                      </mat-form-field>
                    </ng-container>
                  </div>
                  <!--TEXTO-->
                  <div>
                    <ng-container
                      *ngIf="pregunta.tipoPregunta.tipoPregunta === 'TEXTO'"
                    >
                      <mat-form-field class="w-100">
                        <input
                          matInput
                          type="text"
                          [formControlName]="'pregunta_' + pregunta.id"
                        />
                        <mat-error
                          *ngIf="
                            form.get('pregunta_' + pregunta.id)?.invalid &&
                            form.get('pregunta_' + pregunta.id)?.touched
                          "
                        >
                          Este campo es obligatorio
                        </mat-error>
                      </mat-form-field>
                    </ng-container>
                  </div>
                  <!--SI/NO-->
                  <div>
                    <ng-container
                      *ngIf="pregunta.tipoPregunta.tipoPregunta === 'SI/NO'"
                    >
                      <mat-radio-group
                        [formControlName]="'pregunta_' + pregunta.id"
                        class="radio-group"
                      >
                        <mat-radio-button color="primary" value="SI"
                          >Sí</mat-radio-button
                        >
                        <mat-radio-button color="primary" value="NO"
                          >No</mat-radio-button
                        >
                        <mat-error
                          *ngIf="
                            pregunta.obligatoria &&
                            form
                              .get('pregunta_' + pregunta.id)
                              ?.hasError('required') &&
                            form.get('pregunta_' + pregunta.id)?.touched
                          "
                        >
                          Debes seleccionar una opción
                        </mat-error>
                      </mat-radio-group>
                    </ng-container>
                  </div>
                  <!--FECHA-->
                  <div>
                    <ng-container>
                      <mat-form-field
                        class="w-100"
                        *ngIf="pregunta.tipoPregunta.tipoPregunta === 'FECHA'"
                      >
                        <input
                          matInput
                          [matDatepicker]="picker"
                          [formControlName]="'fecha_' + pregunta.id"
                          placeholder="DD/MM/YYYY"
                          readonly
                        />

                        <mat-datepicker-toggle matIconSuffix [for]="picker" [disabled]="readonly">
                        </mat-datepicker-toggle>

                        <mat-datepicker #picker></mat-datepicker>
                        <mat-error
                          *ngIf="
                            pregunta.obligatoria &&
                            form
                              .get('fecha_' + pregunta.id)
                              ?.hasError('required') &&
                            form.get('fecha_' + pregunta.id)?.touched
                          "
                        >
                          La fecha es obligatoria
                        </mat-error>
                      </mat-form-field>
                    </ng-container>
                  </div>
                  <!-- LISTA -->
                  <div *ngIf="pregunta.tipoPregunta.tipoPregunta === 'LISTA'">
                    <div
                      [formGroupName]="'pregunta_' + pregunta.id"
                      class="d-flex flex-wrap gap-2"
                    >
                      <div *ngFor="let opcion of pregunta.opciones">
                        <mat-checkbox
                          color="primary"
                          [formControlName]="'opcion_' + opcion.id"
                          (change)="
                            onCheckboxChange($event, pregunta, opcion.id)
                          "
                        >
                          {{ opcion.opcionRespuesta }}
                        </mat-checkbox>
                      </div>
                    </div>
                    <mat-error
                      *ngIf="
                        form
                          .get('pregunta_' + pregunta.id)
                          ?.hasError('requeridoLista') &&
                        form.get('pregunta_' + pregunta.id)?.touched
                      "
                    >
                      {{
                        pregunta.seleccionMultiple
                          ? "Debes seleccionar al menos una opción"
                          : "Debes seleccionar una opción"
                      }}
                    </mat-error>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </mat-card-content>
</mat-card>
